import { render, staticRenderFns } from "./ReferralDetail.vue?vue&type=template&id=1b0a0dc7&scoped=true"
import script from "./ReferralDetail.vue?vue&type=script&lang=js"
export * from "./ReferralDetail.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetail.vue?vue&type=style&index=0&id=1b0a0dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a0dc7",
  null
  
)

export default component.exports